import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../index';
import Button from '../../Button/Button';
import Input from '../../Input/Input';
import Label from '../../InputLabel';
import style from '../Dialog.module.scss';

const PRESET_COLORS = ['#6366f1', '#ef4444', '#f59e0b', '#10b981', '#8b5cf6', '#06b6d4', '#ec4899', '#64748b', '#3b82f6', '#14b8a6', '#a855f7', '#f472b6', '#fbbf24', '#34d399', '#6ee7b7', '#5eead4'];

export default function CreateExpenseType({
  handleClose, title, open,
  buttonTitle, createJob, initialValues,
}) {
  const { t } = useTranslation();
  const [values, setValues] = useState({});

  useEffect(() => {
    if (initialValues) {
      setValues({ ...initialValues, color: initialValues.color || PRESET_COLORS[0] });
    } else {
      setValues({ color: PRESET_COLORS[0] });
    }
  }, [initialValues, open]);

  const handleExited = () => {
    setValues({});
  };
  const onClose = () => {
    setValues({});
    handleClose();

  };

  return (
    <Dialog handleClose={onClose} onExited={handleExited} open={open} title={title}>
      <div className={style.formControl}>
        <Label text={t('Expense name')} htmlFor='name' />
        <Input
          placeholder={`${t('Enter expense name')}`}
          value={values.name || ''}
          name='name'
          fullWidth
          onChange={(e) => setValues({ ...values, name: e.target.value })}
        />
      </div>

      <div className={style.formControl}>
        <Label text={t('External ID')} htmlFor='external_id' />
        <Input
          placeholder={`${t('Enter external ID')}`}
          value={values.external_id || ''}
          name='external_id'
          fullWidth
          onChange={(e) => setValues({ ...values, external_id: e.target.value })}
        />
      </div>

      <div className={style.formControl}>
        <Label text={t('Color')} htmlFor='color' />
        <div className={style.colorPicker} style={{ marginBottom: '8px' }}>
          {PRESET_COLORS.slice(0, 8).map((color) => (
            <button
              type='button'
              key={color}
              className={`${style.colorCircle} ${values.color === color ? style.colorCircleActive : ''}`}
              style={{ backgroundColor: color }}
              onClick={() => setValues({ ...values, color })}
              aria-label={`${t('Choose color')} ${color}`}
            />
          ))}
        </div>
        <div className={style.colorPicker}>
          {PRESET_COLORS.slice(8, 16).map((color) => (
            <button
              type='button'
              key={color}
              className={`${style.colorCircle} ${values.color === color ? style.colorCircleActive : ''}`}
              style={{ backgroundColor: color }}
              onClick={() => setValues({ ...values, color })}
              aria-label={`${t('Choose color')} ${color}`}
            />
          ))}
        </div>
      </div>
      
      <div className={style.buttonSaveBlock}>
        <Button disabled={!values.name?.trim()} onClick={() => createJob(values)} fillWidth size='big'>
          {buttonTitle}
        </Button>
      </div>
    </Dialog>
  );
}
